// import React, { useState, useEffect } from 'react';
// import { FaMapMarkerAlt, FaEnvelopeOpen, FaPhoneAlt } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import CommonAlert from '../../common/CommonAlert';
// import { addContectUs, failed } from '../../slice/contactusSlice';
// import { useDispatch, useSelector } from 'react-redux';
// import loader from '../../common/loader/loader.gif';
// import { postRequest } from '../../apis/ApiInstence';

// const Contact = () => {
//     const dispatch = useDispatch();
//     const data = useSelector(store => store.contact);

//     const [formData, setFormData] = useState({
//         name: '',
//         mobile: '',
//         subject: '',
//         message: '',
//     });
//     const [errors, setErrors] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);

//     // Validation function
//     const validate = () => {
//         const errors = {};
//         if (!formData.name) {
//             errors.name = "Name is required";
//         }
//         const phoneRegex = /^[0-9]{10}$/;
//         if (!phoneRegex.test(formData.mobile)) {
//             errors.mobile = "Phone number must be exactly 10 digits";
//         }
//         if (!formData.subject) {
//             errors.subject = "Subject is required";
//         }
//         if (!formData.message) {
//             errors.message = "Message is required";
//         }
//         setErrors(errors);
//         return Object.keys(errors).length === 0;
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData({
//             ...formData,
//             [name]: value
//         });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (validate()) {
//             try {
//                 const response = await postRequest(process.env.REACT_APP_BACKEND_URL + 'contactus', formData);
//                 if (response.status === 201) {
//                     setIsSubmitted(true);
//                     setFormData({
//                         name: '',
//                         mobile: '',
//                         subject: '',
//                         message: '',
//                     });
//                 }
//             } catch (error) {
//                 dispatch(failed());
//             }
//         }
//     };

//     const onConfirm = () => {
//         setIsSubmitted(false);
//         dispatch(failed());
//     };

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//    return (
//   <div className="pt-24">
//     {isSubmitted && (
//       <CommonAlert
//         title="Thanks For Contacting Us"
//         text="We will contact you soon"
//         icon="success"
//         confirmButtonText="Ok"
//         onConfirm={onConfirm}
//       />
//     )}

//  <section className="pt-28 pb-20 bg-[#f8f3ee]">
//   <div className="max-w-7xl mx-auto px-6">
//     <div className="grid grid-cols-1 lg:grid-cols-3 rounded-[28px] overflow-hidden shadow-[0_40px_80px_rgba(0,0,0,0.18)]">

//       {/* LEFT PANEL */}
//       <div className="bg-gradient-to-b from-[#b40f1b] to-[#7c0a12] text-white p-10 space-y-10 fade-up fade-delay-1">
        
//         <div className="flex gap-5 premium-card p-6 rounded-2xl bg-white/10">
//           <FaMapMarkerAlt className="text-4xl icon-float" />
//           <div>
//             <h4 className="text-xl font-semibold mb-1">Location</h4>
//             <p className="text-sm leading-relaxed opacity-90">
//               Hindu Devalaya Yatra<br />
//               Tiruchanur, Tirupati<br />
//               Andhra Pradesh – 517503
//             </p>
//           </div>
//         </div>

//         <div className="flex gap-5 premium-card p-6 rounded-2xl bg-white/10">
//           <FaPhoneAlt className="text-4xl icon-float" />
//           <div>
//             <h4 className="text-xl font-semibold mb-1">Make A Call</h4>
//             <p className="text-sm">+91-8885705868</p>
//             <p className="text-sm">+91-7995996555</p>
//           </div>
//         </div>

//         <div className="flex gap-5 premium-card p-6 rounded-2xl bg-white/10">
//           <FaEnvelopeOpen className="text-4xl icon-float" />
//           <div>
//             <h4 className="text-xl font-semibold mb-1">Send A Mail</h4>
//             <p className="text-sm">info@hindudevalayayatra.com</p>
//             <p className="text-sm">hindudevalayayatra@gmail.com</p>
//           </div>
//         </div>
//       </div>

//       {/* RIGHT FORM */}
//       <div className="lg:col-span-2 bg-white p-12 fade-up fade-delay-2">
//         <h2 className="text-4xl font-semibold mb-10 leading-tight">
//           Let’s Talk to Our <span className="text-[#b40f1b]">Yatra Experts</span>
//         </h2>

//         <form className="space-y-8">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             <input className="border-b-2 border-gray-300 focus:border-[#b40f1b] outline-none py-3 text-lg" placeholder="Name" />
//             <input className="border-b-2 border-gray-300 focus:border-[#b40f1b] outline-none py-3 text-lg" placeholder="Phone" />
//           </div>

//           <input className="w-full border-b-2 border-gray-300 focus:border-[#b40f1b] outline-none py-3 text-lg" placeholder="Email" />

//           <textarea rows="4" className="w-full border-b-2 border-gray-300 focus:border-[#b40f1b] outline-none py-3 text-lg resize-none" placeholder="Tell Us About Project"></textarea>

//           <button className="bg-[#b40f1b] hover:bg-[#7c0a12] transition px-12 py-4 text-white text-lg font-medium rounded-full shadow-lg">
//             SEND MESSAGE
//           </button>
//         </form>
//       </div>
//     </div>
//   </div>
// </section>


//     {/* MAP */}
//     <div className="mt-16">
//       <iframe
//         title="map"
//         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28964.53148025258!2d79.90503552099898!3d24.84449652628371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3982e606a486e093%3A0x29e9b56680aaa724!2sSevagram%2C%20Khajuraho%2C%20Madhya%20Pradesh%20471606!5e0!3m2!1sen!2sin!4v1734104981234!5m2!1sen!2sin"
//         loading="lazy"
//         className="w-full h-[420px] border-0"
//         referrerPolicy="no-referrer-when-downgrade"
//       />
//     </div>
//   </div>
// );

// };

// export default Contact;
import ContactForm from "../../components/contact/ContactForm";

const Contact = () => {
  return <ContactForm showMap={true} />;
};

export default Contact;
